import { clearCart } from '../../api/checkout';
import { ClassNames } from '../../utils/dom/css-classes';
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../Modal';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const NAME = 'CheckoutModal';
const ENTER_KEY = '13';

const TagNames = {
	IMG: 'IMG',
	A: 'A'
};

const SELECTOR_NAV_SEARCH = '.lta-mega-nav__search';
const SELECTOR_MODAL_DISMISS = '.lta-checkout-modal-dismiss';
const SELECTOR_MODAL_LEAVE = '.lta-checkout-modal-leave';
const SELECTOR_MODAL_STAY = '.lta-checkout-modal-stay';
const SELECTOR_BODY = 'body';
const SELECTOR_BACKDROP_CHECKOUT = '.lta-modal-backdrop-checkout';
const SELECTOR_CHECKOUT = '.p-checkout';
const SELECTOR_SEARCH_INPUT = '.js-search-field-input';
const SELECTOR_OPEN_MODAL = 'lta-modal-open';
const SELECTOR_SEARCH_BUTTON = 'lta-search-field__button';
const SELECTOR_ANCHOR = 'a';
const REDIRECT_URL = localStorage.getItem("leaveCheckoutModalUrl")

class CheckoutModal extends Modal {
	constructor(element) {
		super(element);
		this.searchNavigationWrapper = SelectorEngine.findOne(SELECTOR_NAV_SEARCH);
		this.dismissBtn = SelectorEngine.findOne(SELECTOR_MODAL_DISMISS, element);
		this.leaveBtn = SelectorEngine.findOne(SELECTOR_MODAL_LEAVE, element);
		this.redirectUrl = REDIRECT_URL;
		this.stayBtn = SelectorEngine.findOne(SELECTOR_MODAL_STAY, element);
		this.body = SelectorEngine.findOne(SELECTOR_BODY);
		this.backdrop = SelectorEngine.findOne(SELECTOR_BACKDROP_CHECKOUT, this.body);
		// TODO: Pass in this selector as a parameter
		this.wrapper = SelectorEngine.findOne(SELECTOR_CHECKOUT);
		this.searchInput = SelectorEngine.findOne(SELECTOR_SEARCH_INPUT, this.searchNavigationWrapper);
		this.fromBack = false;
		this.previous = undefined;
		this.url = undefined;
		// eslint-disable-next-line unicorn/no-array-callback-reference, unicorn/no-array-method-this-argument
		this._pageView = SelectorEngine.find(SELECTOR_ANCHOR, this.wrapper);

		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		// Detect backbutton
		// Retrieve previous url since history.go() doesn't work as expected after history.pushstate
		this.retrieveURL();

		window.history.pushState(undefined, undefined, '');

		EventHandler.on(window, Events.Popstate, (event) => {
			this.fromBack = true;
			event.preventDefault();
			this.openModal();
		});

		EventHandler.on(this.searchInput, Events.Keydown, (event) => {
			const key = event.keyCode || event.which;
			if (key == ENTER_KEY) {
				this.fromBack = true;
				event.preventDefault();
				this.openModal();
			}
		});

		EventHandler.on(window, Events.Click, (event) => {
			if (event.target.tagName === TagNames.IMG) {
				if (event.target.parentNode.href && event.target.parentNode.href.length > 1) {
					this.preventNavigation(event);
				}
			} else if (event.target.classList.contains(SELECTOR_SEARCH_BUTTON)) {
				this.preventNavigation(event);
			} else if (
				event.target.tagName === TagNames.A &&
				!this._pageView.includes(event.target) &&
				event.target.href &&
				event.target.href.length > 1
			) {
				this.preventNavigation(event);
			}
		});

		EventHandler.on(this.stayBtn, Events.Click, () => {
			this.closeModal();
		});

		EventHandler.on(this.leaveBtn, Events.Click, () => {
			const { bookingToken } = window.lta?.clubspark?.basket || {};

			clearCart(bookingToken);
			this.closeModal();
			startLoadingAnimation();
			EventHandler.off(window, Events.Popstate);
			window.location.href = this.redirectUrl? this.redirectUrl : this.url;
		});

		EventHandler.on(this.dismissBtn, Events.Click, () => this.closeModal());
	}

	preventNavigation(event) {
		event.preventDefault();
		this.fromBack = false;
		this.getLinkHref(event);
		this.openModal();
	}

	getLinkHref(event) {
		this.url = event.target.href;
	}

	retrieveURL() {
		this.previous = document.referrer;
	}

	closeModal() {
		this.body.classList.remove(SELECTOR_OPEN_MODAL);
		this._element.classList.remove(ClassNames.Show);
		this._element.style.display = ClassNames.None;
		this.backdrop.classList.remove(ClassNames.Show);
	}

	openModal() {
		this.body.classList.add(SELECTOR_OPEN_MODAL);
		this._element.classList.add(ClassNames.Show);
		this._element.style.display = ClassNames.Block;
		this.backdrop.classList.add(ClassNames.Show);
		this._element.focus();
	}
}

export default CheckoutModal;
